import React, { useState, useEffect } from "react";
import "./Login.css";
import axios from "axios";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Logoimg from "../../assets/img/logo.png";
import safe from "../../assets/img/safe.png";
import { UserOutlined, UserAddOutlined } from "@ant-design/icons";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";
import loading1 from "../../assets/img/loading-gif.gif";
import ranabhaimatka from "../../assets/img/ranabhaimatka.apk";
import { Spinner } from "react-bootstrap";
import support from "../../assets/img/support1.png";
import { decryptData, encryptData } from "../../decryptHelper";

/* ------------------------------------------------------------------ */
/* Browser detection (component ke bahar, ek hi baar calculate hota hai) */
/* ------------------------------------------------------------------ */
const UA = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
const isIOS = /iPad|iPhone|iPod/.test(UA);
const isAndroid = /Android/i.test(UA);
// Facebook / Messenger / Instagram in-app browser
const isInAppBrowser = /FBAN|FBAV|FB_IAB|FB4A|FBIOS|Instagram|Messenger/i.test(UA);

const MySwal = withReactContent(Swal);

/* ------------------------------------------------------------------ */
/* iOS "Add to Home Screen" offcanvas                                  */
/* (component ke bahar rakha hai taaki har render pe remount na ho)    */
/* ------------------------------------------------------------------ */
function OffCanvasExample({ name, ...props }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Offcanvas show={show} onHide={() => setShow(false)} {...props}>
        <Offcanvas.Header>
          <Offcanvas.Title className="text-white border-bottom-custum">
            {" "}
            Add To Home Screen
          </Offcanvas.Title>
          <div className="col-md-2 cancelbtn" onClick={() => setShow(false)}>
            {" "}
            Cancel{" "}
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="text-white">
          <p className="text-center text-white content-pwa">
            This website has app functionality. Add it to your home screen to
            use it in fullscreen and while offline.
          </p>
          <div>
            <ul className="list-style-none">
              <li className="d-flex ">
                <i className="bi bi-box-arrow-up arrowcolor"></i>
                <span>1 Press the 'Share' button</span>
              </li>
              <li>
                <i className="bi bi-plus-square"></i>
                <span>2 Press 'Add to Home Screen'</span>
              </li>
            </ul>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <button
        type="button"
        onClick={() => setShow(true)}
        className="btn btn-ronded text-light pwabtn"
      >
        {name}
      </button>
    </>
  );
}

function Login() {
  const navigate = useNavigate();

  /* ---------------- Splash screen ---------------- */
  const [loadingsplash, setloadingsplash] = useState(true);
  useEffect(() => {
    const splashTimeout = setTimeout(() => {
      setloadingsplash(false);
    }, 4000);
    return () => clearTimeout(splashTimeout);
  }, []);

  /* ---------------- PWA install ---------------- */
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(true);

  useEffect(() => {
    const beforeInstallPromptHandler = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };
    const appInstalledHandler = () => {
      localStorage.setItem("isAppInstalled", "true");
      setShowInstallButton(false);
      setDeferredPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", beforeInstallPromptHandler);
    window.addEventListener("appinstalled", appInstalledHandler);
    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        beforeInstallPromptHandler,
      );
      window.removeEventListener("appinstalled", appInstalledHandler);
    };
  }, []);

  const handleInstallClick = async () => {
    // 1) Chrome / normal browser: asli install popup
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const choice = await deferredPrompt.userChoice;
      if (choice.outcome === "accepted") {
        localStorage.setItem("isAppInstalled", "true");
        setShowInstallButton(false);
      }
      setDeferredPrompt(null);
      return;
    }

    // 2) Facebook / Instagram in-app browser (yahan install possible nahi)
    if (isInAppBrowser) {
      if (isAndroid) {
        const url = window.location.href;
        const noProtocol = url.replace(/^https?:\/\//, "");

        // Chrome me kholne ki koshish
        window.location.href =
          `intent://${noProtocol}#Intent;scheme=https;package=com.android.chrome;` +
          `S.browser_fallback_url=${encodeURIComponent(url)};end`;

        // Agar Chrome na khule to instruction dikhao
        setTimeout(() => {
          MySwal.fire({
            title: "Chrome me kholein",
            html: "Upar <b>⋮ (3 dots)</b> dabayein, phir <b>'Open in Chrome'</b> chunein. Wahan se <b>Install</b> karein.",
            icon: "info",
          });
        }, 1500);
      } else {
        MySwal.fire({
          title: "Safari me kholein",
          html: "<b>⋯</b> dabayein, phir <b>'Open in Safari'</b> chunein. Phir <b>Share</b>, phir <b>Add to Home Screen</b>.",
          icon: "info",
        });
      }
      return;
    }

    // 3) Baaki case: prompt abhi ready nahi
    MySwal.fire({
      title: "Install karein",
      html: "Browser menu (⋮) me <b>'Install app'</b> ya <b>'Add to Home screen'</b> chunein.",
      icon: "info",
    });
  };

  /* ---------------- Referral code ---------------- */
  const [RefCode, setRefCode] = useState();
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("reffercode");
    setRefCode(code ? code : "withoutrefcode");
  }, []);

  /* ---------------- Already logged in / already installed ---------------- */
  useEffect(() => {
    const userid = localStorage.getItem("userid");
    if (userid) {
      navigate("/Home");
    }
    const isAppInstalled = localStorage.getItem("isAppInstalled");
    if (isAppInstalled) {
      setShowInstallButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ---------------- State ---------------- */
  const [browserId, setBrowserId] = useState("");
  const [BasicDetails, setBasicDetails] = useState([]);
  const [isShown, setIsShown] = useState(false);
  const [otpnumbers, otpnumber] = useState();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading1] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isValidMobile, setIsValidMobile] = useState(false);
  const [mobile, mobilenumber] = useState("");

  const [isValidMpin, setIsValidMpin] = useState(false);
  const [mpin, setmpin] = useState("");
  const [message, setMessage] = useState("");
  const [color, setColor] = useState("black");

  // login ke baad ye values state me bhi rakhi gayi thi (original code)
  const [, setOtpsend] = useState(null);
  const [, setuser_id] = useState(null);
  const [, settoken] = useState(null);
  const [, settokenone] = useState(null);
  const [, setdev_id] = useState(null);

  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    issuemobile: "",
    description: "",
  });

  sessionStorage.setItem("token", "");

  /* ---------------- Browser id + login page data ---------------- */
  useEffect(() => {
    fetchData();
    let browserIdd = Cookies.get("browserId");
    if (!browserIdd) {
      browserIdd = uuidv4();
      Cookies.set("browserId", browserIdd, { expires: 7 });
    }
    setBrowserId(browserIdd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ---------------- Resend timer ---------------- */
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  /* ---------------- Input handlers ---------------- */
  const onFinish = (e) => {
    if (e && e.preventDefault) e.preventDefault();
  };

  function onInputChange(e) {
    const mobileNumber = e.target.value.replace(/\D/g, "");
    mobilenumber(mobileNumber);
    setIsValidMobile(/^[0-9]{10}$/.test(mobileNumber));
  }

  function onInputChangePassword(e) {
    const numericValue = e.target.value.replace(/\D/g, "");
    e.target.value = numericValue;
    otpnumber(numericValue);
  }

  const checkStrength = (pwd) => {
    const hasLetter = /[a-zA-Z]/.test(pwd);
    const hasNumber = /[0-9]/.test(pwd);
    const hasSpecial = /[^a-zA-Z0-9]/.test(pwd);
    const hasRepeat = /(.)\1/.test(pwd);

    if (hasSpecial) {
      setColor("red");
      setIsValidMpin(false);
      return "Only AlphaNumberic Allowed";
    }
    if (hasRepeat) {
      setColor("red");
      setIsValidMpin(false);
      return "Repeated Not Allowed";
    }
    if (hasLetter && hasNumber && pwd.length >= 6) {
      setColor("green");
      setIsValidMpin(true);
      return "Perfect 👍";
    } else if (hasLetter || hasNumber) {
      setColor("orange");
      setIsValidMpin(false);
      return "Weak";
    } else {
      setColor("red");
      setIsValidMpin(false);
      return "Invalid";
    }
  };

  const handleChangeMpin = (e) => {
    const input = e.target.value;
    setmpin(input);
    setMessage(checkStrength(input));
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  /* ---------------- Login ---------------- */
  const saveLogin = (d) => {
    setOtpsend(d.otp);
    setuser_id(d.user_id);
    settoken(d.token);
    settokenone(d.tokenl);
    setdev_id(d.device_id);

    localStorage.setItem("userid", d.user_id);
    localStorage.setItem("dev_id", d.device_id);
    localStorage.setItem("token", d.token);
    localStorage.setItem("tokenl", d.tokenl);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (mpin === "A12345") {
      MySwal.fire({ title: "Wrong MPIN", icon: "error", timer: 2000 });
      return;
    }
    if (timer > 0) return;
    setTimer(60);

    try {
      setLoading(true);
      const url = `${process.env.REACT_APP_API_URL_NODE}login-new-encrpt`;
      const requestData = {
        mob: mobile,
        mpin: mpin,
        dev_id: browserId,
        app_id: process.env.REACT_APP_API_ID,
        RefCode: RefCode,
      };
      const encryptedText = encryptData(requestData);
      const datasend = { data: encryptedText };
      const config = {
        method: "POST",
        url: url,
        headers: { "Content-Type": "application/json" },
        data: datasend,
      };

      axios(config)
        .then(function (response) {
          const data = decryptData(response.data.encryptedResponse);
          setLoading(false);

          if (data.data.success == 1) {
            MySwal.fire({
              title: "Login Successfully",
              icon: "success",
              timer: 2000,
            }).then(() => {
              saveLogin(data.data);
              navigate("/Home");
            });
          } else if (data.data.success == 2) {
            setIsShown(true);
          } else if (data.data.success == 3 || data.data.success == 7) {
            setIsShown(false);
            MySwal.fire({
              title: data.data.message,
              icon: "error",
              timer: 2000,
            });
          } else if (data.data.success == 5) {
            setIsShown(false);
            MySwal.fire({
              title: data.data.title,
              html: data.data.message,
              icon: "error",
              confirmButtonText: "ठीक है",
              allowOutsideClick: false,
            });
          } else if (data.data.success == 6) {
            setIsShown(false);
            MySwal.fire({
              title: "Block",
              html: data.data.message,
              icon: "error",
              confirmButtonText: "Create New MPIN",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/forget-mpin";
              }
            });
          } else {
            setIsShown(false);
          }
        })
        .catch(function (error) {
          console.error("There was a problem with the fetch operation:", error);
          setIsShown(false);
        })
        .finally(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1500);
        });
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      setIsShown(false);
      setLoading(false);
    }
  };

  const reSendotp = async () => {
    if (timer > 0) return;
    setTimer(60);
    try {
      const url = `${process.env.REACT_APP_API_URL_NODE}login-new`;
      const requestData = {
        mob: mobile,
        dev_id: browserId,
        app_id: process.env.REACT_APP_API_ID,
      };
      const config = {
        method: "POST",
        url: url,
        headers: { "Content-Type": "application/json" },
        data: requestData,
      };

      axios(config)
        .then(function (response) {
          if (response.data.success === "1") {
            MySwal.fire({ title: "Otp Send", icon: "success", timer: 2000 });
          } else {
            MySwal.fire({
              title: response.data.message,
              icon: "error",
              timer: 2000,
            });
          }
        })
        .catch(function (error) {
          console.error("There was a problem with the fetch operation:", error);
          setIsShown(false);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      setIsShown(false);
      setLoading(false);
    }
  };

  const loginChk = async () => {
    setLoading1(true);

    const url = `${process.env.REACT_APP_API_URL_NODE}login-chkotp-new-enc`;
    const requestData = {
      mob: mobile,
      otp: otpnumbers,
      mpin: mpin,
    };
    const encryptedText = encryptData(requestData);
    const datasend = { data: encryptedText };
    const config = {
      method: "POST",
      url: url,
      headers: { "Content-Type": "application/json" },
      data: datasend, // NOTE: axios me "body" nahi, "data" use hota hai
    };

    axios(config)
      .then(function (response) {
        if (response.data.success == 1) {
          MySwal.fire({
            title: "Login Successfully",
            icon: "success",
            timer: 2000,
          }).then(() => {
            saveLogin(response.data);
            navigate("/Home");
          });
        } else {
          setLoading1(false);
          MySwal.fire({ title: "Invalid Otp", icon: "error", timer: 2000 });
        }
      })
      .catch(function (error) {
        console.error(error);
        setLoading1(false);
      });
  };

  /* ---------------- Login page data (title, social links) ---------------- */
  const fetchData = async () => {
    const url = `${process.env.REACT_APP_API_URL_NODE}login-page`;
    const config = {
      method: "POST",
      url: url,
      headers: { "Content-Type": "application/json" },
    };

    axios(config)
      .then(function (response1) {
        const response = decryptData(response1.data.encryptedResponse);
        setBasicDetails(response.data.data);
        localStorage.setItem(
          "insta",
          response.data.data.login_page_instagram_link,
        );
        localStorage.setItem(
          "facebook",
          response.data.data.login_page_facebook_link,
        );
      })
      .catch((error) => console.error(error));
  };

  /* ---------------- Support form ---------------- */
  const handleSubmitIssue = (e) => {
    e.preventDefault();

    const url = `${process.env.REACT_APP_API_URL_NODE}support-submit`;
    const encryptedText = encryptData(formData);
    const datasend = { data: encryptedText };
    const config = {
      method: "POST",
      url: url,
      headers: { "Content-Type": "application/json" },
      data: datasend, // NOTE: axios me "body" nahi, "data" use hota hai
    };

    axios(config)
      .then(function (response) {
        if (response.data.success == 1) {
          MySwal.fire({
            title: "Submit Successfully",
            icon: "success",
            timer: 2000,
          }).then(() => {
            setShowPopup(false);
            setFormData({ issuemobile: "", description: "" });
          });
        } else if (response.data.success == 2) {
          MySwal.fire({
            title: response.data.message,
            icon: "error",
            timer: 5000,
          });
        } else {
          MySwal.fire({ title: "Error", icon: "error", timer: 2000 });
        }
      })
      .catch(function (error) {
        console.error(error);
        MySwal.fire({ title: "Error", icon: "error", timer: 2000 });
      });
  };

  /* ================================================================== */
  /* UI                                                                  */
  /* ================================================================== */
  return (
    <>
      {/* Splash screen */}
      <div className={`splash-screen ${loadingsplash ? "visible" : "hidden"}`}>
        <div className="logonew">
          <img src={Logoimg} className="img-fluid" alt="logo" />
        </div>
        <div className="safe">
          <img src={safe} className="img-fluid" alt="safe" />
        </div>
        <p className="trust">Trust And Seal Babaclubs 100% Safe And Secure</p>
      </div>

      <div className="Loginpage">
        <div className="loginform position-relative">
          <div
            className="width_77 position-relative"
            style={{ marginTop: "20px" }}
          >
            <div style={{ fontFamily: "sans-serif" }}>
              {/* पहला बॉक्स (Red Text) */}
              <h2
                style={{
                  backgroundColor: "#fce8b2",
                  color: "#cc0000",
                  border: "1px solid #f0c36d",
                  padding: "15px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "normal",
                  textAlign: "left",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                {BasicDetails.login_page_title ||
                  "फरीदाबाद, गाजियाबाद, गली और दिसावर गेम खेलने के वाले नीचे से एप्लीकेशन डाउनलोड करें। यहां मिलता है आपको सबसे ज्यादा टेट 10 के 950 और सबसे फास्ट हैंड हाफ पेमेंट।"}
              </h2>

              {/* दूसरा बॉक्स (Yellow Text) */}
              <h2
                style={{
                  color: "#ffff00",
                  padding: "15px",
                  margin: "0",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "1.6",
                  textAlign: "left",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                अपने रेफरल कोड के माध्यम से किसी व्यक्ति को जोड़ने पर, यदि वह
                व्यक्ति बेट लगाता है, तो उसके द्वारा लगाए गए बेट पर आपको{" "}
                <span
                  style={{
                    color: "#cc0000",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                  }}
                >
                  5% कमीशन
                </span>{" "}
                प्राप्त होगा।
              </h2>
            </div>

            <p
              style={{
                margin: 0,
                padding: "8px 14px",
                textAlign: "center",
                fontSize: "13px",
                fontWeight: "600",
                color: "#ffffff",
                letterSpacing: "0.5px",
                borderRadius: "8px",
              }}
            >
              Powered by{" "}
              <span
                style={{
                  color: "#ffd700",
                  fontSize: "14px",
                  fontWeight: "800",
                  letterSpacing: "0.7px",
                  textShadow: "0 0 8px rgba(255,215,0,0.5)",
                }}
              >
                Babaji Khaiwal
              </span>
            </p>
          </div>

          <div className="logobgshape d-flex justify-content-center align-items-center ">
            <div className="logo ">
              <img src={Logoimg} width="150" alt="logo" />
            </div>
          </div>

          <div className="login-form">
            <div className="form-login-design">
              <form onSubmit={onFinish}>
                <div className="row">
                  {!isShown && (
                    <>
                      {/* Mobile Number */}
                      <div className="col-12 mb-2">
                        <label className="label_custum">Mobile Number</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <UserOutlined />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            name="mobileNum"
                            maxLength={10}
                            placeholder="Mobile Number"
                            value={mobile}
                            onChange={onInputChange}
                          />
                        </div>
                      </div>

                      {/* MPIN */}
                      <div className="col-12 mb-2">
                        <p className="example">
                          MPIN{" "}
                          <span style={{ color: "#fd6060" }}>(ex. A12345)</span>
                        </p>
                        <div className="input-group">
                          <span className="input-group-text">
                            <UserOutlined />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="MPIN"
                            value={mpin}
                            onChange={handleChangeMpin}
                          />
                        </div>

                        {message && (
                          <p className="errermsg" style={{ color }}>
                            {message}
                          </p>
                        )}
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <span>
                            <a
                              href="/create-account"
                              className="newpin gap-2 d-flex align-items-center"
                            >
                              <UserAddOutlined /> Create New Account
                            </a>
                          </span>
                          <span>
                            <a href="/forget-mpin" className="newpin forgetpin">
                              Forgot MPIN
                            </a>
                          </span>
                        </div>
                      </div>
                    </>
                  )}

                  {/* OTP */}
                  {isShown && (
                    <div className="col-12 mb-1">
                      <input
                        type="number"
                        className="form-control p-2"
                        onChange={onInputChangePassword}
                        placeholder="Enter OTP"
                      />
                    </div>
                  )}

                  {/* Buttons */}
                  <div className="col-12">
                    {loading ? (
                      <div className="d-flex justify-content-center position-relative loginloader">
                        <img
                          src={loading1}
                          className="px-2 loaderfile"
                          style={{ width: "50px" }}
                          alt="Loading..."
                        />
                      </div>
                    ) : isShown ? (
                      <div className="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          disabled={loading2}
                          className="btn_login btn btn-success w-100"
                          onClick={loginChk}
                        >
                          Login
                          {loading2 && <Spinner animation="border" size="sm" />}
                        </button>

                        <button
                          type="button"
                          disabled={loading || timer > 0}
                          className="btn btn-primary w-100"
                          onClick={reSendotp}
                        >
                          {timer > 0 ? `Resend OTP in ${timer}s` : "Resend OTP"}
                          {loading && <Spinner animation="border" size="sm" />}
                        </button>
                      </div>
                    ) : (
                      <div className="my-2">
                        <button
                          onClick={onSubmit}
                          type="submit"
                          className={`btn_login btn w-100 text-white ${isValidMobile && isValidMpin
                              ? "btn-success"
                              : "btn-secondary"
                            }`}
                          disabled={!isValidMobile || !isValidMpin}
                        >
                          Login
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </form>

              {/* ---------- iPhone ---------- */}
              {isIOS && isInAppBrowser && (
                <p
                  style={{
                    color: "#ffd700",
                    textAlign: "center",
                    fontSize: "13px",
                    marginTop: "10px",
                  }}
                >
                  Install ke liye <b>⋯</b> dabakar <b>"Open in Safari"</b>{" "}
                  chunein.
                </p>
              )}
              {isIOS && (
                <div className="d-flex jusitfy-content-center">
                  {["Install Web Application IOS"].map((placement, idx) => (
                    <OffCanvasExample
                      key={idx}
                      placement={placement}
                      name={placement}
                    />
                  ))}
                </div>
              )}

              {/* ---------- Android / Desktop ---------- */}

              {!isIOS && !isInAppBrowser && showInstallButton && (
  <div className="d-flex gap-2 align-items-center" style={{ marginTop: "10px" }}>
    <button
      type="button"
      className="btn btn-ronded text-light pwabtn pwa_bbtn_color w-100"
      onClick={handleInstallClick}
    >
      Install Application1
    </button>
  </div>
)}
              {/* {!isIOS && showInstallButton && (
                <div className="d-flex gap-2 align-items-center margin-top: 10px" >
                  <button
                    type="button"
                    className="btn btn-ronded text-light pwabtn pwa_bbtn_color w-100"
                    onClick={handleInstallClick}
                  >
                    {isInAppBrowser
                      // ? "Chrome me Open karke Install karein"
                      ? "Install Application1"
                      : "Install Application1"}
                  </button>
                </div>
              )} */}
              {/* <div className="d-flex gap-2 align-items-center" style={{marginTop:"10px"}}>
                <a
                  href={ranabhaimatka}
                  download="ranabhaimatka.apk"
                  className="btn btn-ronded text-light pwabtn pwa_bbtn_color w-100"
                  style={{
                    textDecoration: "none",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  Install Application 2
                </a>
              </div> */}

  <div className="d-flex gap-2 align-items-center" style={{ marginTop: "10px" }}>
    <a
      href={ranabhaimatka}
      download="ranabhaimatka.apk"
      className="btn btn-ronded text-light pwabtn pwa_bbtn_color w-100"
      style={{
        textDecoration: "none",
        textAlign: "center",
        cursor: "pointer",
      }}
    >
      Install Application 2
    </a>
  </div>


              {/* Social links */}
              <div className="socialmedialink d-flex justify-content-center align-items-center gap-2">
                <div className="socialmedianew ">
                  <Link to={BasicDetails.login_page_facebook_link || "#"}>
                    <i className="bi bi-facebook wp-icon fa-facebook-f fa-lg" />
                  </Link>
                </div>
                <div className="socialmedianew ">
                  <Link to={BasicDetails.login_page_instagram_link || "#"}>
                    <i className="bi bi-instagram wp-icon fa-instagram fa-lg"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Support Pop up */}
          <div className="call-buton" onClick={() => setShowPopup(true)}>
            <img src={support} alt="support" />
          </div>
          {showPopup && (
            <div className="popup-overlay">
              <div className="popup-box">
                <h2>Support Form</h2>
                <form onSubmit={handleSubmitIssue}>
                  <div className="form-group">
                    <label>Mobile</label>
                    <input
                      type="number"
                      name="issuemobile"
                      value={formData.issuemobile}
                      onChange={handleChange}
                      required
                      pattern="\d{9,10}"
                    />
                  </div>
                  <div className="form-group">
                    <label>Issue</label>
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      rows="3"
                      required
                    ></textarea>
                  </div>
                  <div className="form-actions">
                    <button
                      type="button"
                      className="cancel btn w-100"
                      onClick={() => setShowPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-ronded text-light pwabtn pwa_bbtn_color w-100"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Login;